module.exports = __webpack_public_path__ + "img/foben.c3c68bc3.png";